import React from 'react';
import './SingleLineField.css';
import FieldGrid from '../FieldGrid/FieldGrid';
import ArcToggle from '../ArcToggle/ArcToggle';
import ArcTextField from '../ArcTextField/ArcTextField';
import ArcChoiceGroup from '../ArcChoiceGroup/ArcChoiceGroup';
import ArcDropdown from '../ArcDropdown/ArcDropdown';
import ArcDate from '../ArcDate/ArcDate';
import ArcFilteredCombo from '../ArcFilteredCombo/ArcFilteredCombo';
import ArcCombo from '../ArcCombo/ArcCombo';
import ArcNumber2 from '../ArcNumber/ArcNumber2';
import ArcTime from '../Arctime/ArcTime';
import ArcHierarchy from '../ArcHierarchy/ArcHierarchy';
import ArcUpload from '../ArcUpload/ArcUpload';
import { SearchBox, Separator, TextField } from '@fluentui/react';
import ArcColourPicker from '../ArcColourPicker/ArcColourPicker';
import CraftedComponentFactory from '../../Crafted/CraftedComponentFactory';
import ArcPicker from '../ArcPicker/ArcPicker';
import ReportFilter from '../../Crafted/Reports/ReportFilter/ReportFilter';
import ArcFieldSelector from '../ArcFieldSelector/ArcFieldSelector';
import ArcPlainText from '../ArcPlaintText/ArcPlainText';
import ArcOrganismList from '../ArcOrganismList/ArcOrganismList';
import MicDosageNumber from '../ArcNumber/MicDosageNumber';
import FormattedJsonDetails from '../../Crafted/Queue/FormattedJsonDetails/FormattedJsonDetails';

document.addEventListener("contextmenu", (event) => {
    event.preventDefault();
});

const SingleLineField = (props) => {

    const valueChangeHandler = (event, value) => {
        props.changeHandler(props.config.Id, value)
    }

    const textChangeHandler = (event, value) => {
        const maxValue = isNaN(parseInt(props.config.Max)) ? 100000 : Number(props.config.Max);
        value = value.length > maxValue ? value.substring(0,maxValue) : value;
        value = value.replace(/[|'"]/g, '');

        props.changeHandler(props.config.Id, value)
    }

    const comboBoxChangeHandler = (event, value, overrideId) => {
        const id = overrideId === undefined || typeof overrideId !== 'string' ? props.config.Id : overrideId;
        if (value !== undefined) {
            props.changeHandler(id, value.key);
        } else {
            props.changeHandler(id, undefined);
        }
    }

    const radioChangeHandler = (event, value) => {
        props.changeHandler(props.config.Id, value)
    }

    const label = props.config.Label;

    let fieldToDisplay;
    switch (props.config.Type) {
        case "singleline":
            fieldToDisplay = <ArcTextField 
                id={props.config.Id} 
                config={props.config} 
                onKeyDown={props.onKeyDown}
                changeHandler={valueChangeHandler}
                focusOut={props.focusOut} 
                first={props.first}
                >
            </ArcTextField>
            break;
        case "multiline":
            fieldToDisplay = <TextField
                                label={label}
                                id={props.config.Id}
                                multiline autoAdjustHeight
                                required={props.config.Required}
                                placeholder={props.config.Placeholder}
                                onChange={textChangeHandler}
                                onKeyDown={props.onKeyDown}
                                focusOut={props.focusOut} 
                                defaultValue={props.config.value}
                            />;
            break;
        case "password":
            fieldToDisplay = <TextField
                                id={props.config.Id}
                                label={props.config.Label}
                                onKeyDown={props.onKeyDown}
                                autoComplete="new-password"
                                type="password"
                                placeholder={props.config.Placeholder}
                                canRevealPassword={true}
                                required={props.config.Required}
                                onChange={textChangeHandler}
                             />;
            break;
        case "toggle":
            fieldToDisplay = <ArcToggle 
                config={props.config} 
                valueChangeHandler={valueChangeHandler} 
                showText={true}
                first={props.first}
                onKeyDown={props.onKeyDown}
            >
            </ArcToggle>
            break;
        case "dropdown":
            fieldToDisplay = <ArcDropdown
                                config={props.config}
                                valueChangeHandler={props.changeHandler}
                                first = {props.first}
                                onKeyDown={props.onKeyDown}
                             ></ArcDropdown>
            break;
        case "combobox":
            fieldToDisplay = <ArcCombo
                                config={props.config}
                                changeHandler={props.changeHandler}
                                first = {props.first}
                                onKeyDown={props.onKeyDown}
                                >
                            </ArcCombo>
            break;
        case "picker":
            fieldToDisplay = <ArcPicker
                                config={props.config}
                                valueChangeHandler={props.changeHandler}
                                onKeyDown={props.onKeyDown}
                            ></ArcPicker>
            break;
        case "filteredcombo":
            fieldToDisplay = <ArcFilteredCombo config={props.config} changeHandler={comboBoxChangeHandler} onKeyDown={props.onKeyDown}></ArcFilteredCombo>
            break;
        case "date":
            fieldToDisplay = <ArcDate config={props.config} changeHandler={valueChangeHandler} focusOut={props.focusOut} onKeyDown={props.onKeyDown}></ArcDate>
            break;
        case "search":
            fieldToDisplay = <SearchBox
                                id={props.config.Id}
                                onKeyDown={props.onKeyDown}
                                placeholder={props.config.Placeholder}
                                label={label}/>;
            break;
        case "radio":
            fieldToDisplay = <ArcChoiceGroup
                                config={props.config}
                                onKeyDown={props.onKeyDown}
                                radioChangeHandler={radioChangeHandler}
                            />;
            break;
        case "number":
            fieldToDisplay = <ArcNumber2
                                key={props.key} 
                                config={props.config} 
                                changeHandler={valueChangeHandler}
                                first={props.first}
                                focusOut={props.focusOut}
                                onKeyDown={props.onKeyDown}
                            />;
            break;
        case "micdosage":
            fieldToDisplay = <MicDosageNumber
                                key={props.key} 
                                config={props.config} 
                                changeHandler={valueChangeHandler}
                                first={props.first}
                            />;
            break;
        case "time":
            fieldToDisplay = <ArcTime 
                                key={props.key} 
                                config={props.config} 
                                onKeyDown={props.onKeyDown}
                                changeHandler={valueChangeHandler}
                                >
                            </ArcTime>
            break;
        case "fieldgrid":
            fieldToDisplay = <FieldGrid config={props.config} changeHandler={valueChangeHandler} onKeyDown={props.onKeyDown} language={props.language}></FieldGrid>;
            break;
        case "space":
            fieldToDisplay = <br />
            break;
        case "separator":
            fieldToDisplay = <Separator>{label}</Separator>
            break;
        case "crafted":
            fieldToDisplay = <CraftedComponentFactory config={props.config} changeHandler={valueChangeHandler} language={props.language}></CraftedComponentFactory>
            break
        case "colourpicker":
            fieldToDisplay = <ArcColourPicker config={props.config} changeHandler={valueChangeHandler} language={props.language}></ArcColourPicker>;
            break;
        case "reportfilter":
            fieldToDisplay = <ReportFilter specimenid={props.id} language={props.language} config={props.config} changeHandler={valueChangeHandler}></ReportFilter>
            break;
        case "fieldselector":
            fieldToDisplay = <ArcFieldSelector config={props.config} data={props.config.value} changeHandler={valueChangeHandler} language={props.language}></ArcFieldSelector>
            break;
        case "text":
            fieldToDisplay = <TextField id={props.config.Id} label={props.config.Label} disabled required={props.config.Required} onChange={valueChangeHandler} focusOut={props.focusOut} value={props.config.value} readOnly = {true}/>;
            break;
        case "multitext":
            fieldToDisplay = <TextField id={props.config.Id} label={props.config.Label} multiline autoAdjustHeight disabled required={props.config.Required} onChange={valueChangeHandler} focusOut={props.focusOut} value={props.config.value} readOnly = {true}/>;
            break;
        case "plaintext":
            fieldToDisplay = <ArcPlainText config={props.config} value={props.config.value}></ArcPlainText>  
            break; 
        case "organismlist":
            fieldToDisplay = <ArcOrganismList config={props.config} value={props.config.value} language={props.language} changeHandler={valueChangeHandler} onKeyDown={props.onKeyDown}></ArcOrganismList>
            break;
        case "hierarchy":
            fieldToDisplay = <ArcHierarchy config={props.config} changeHandler={props.changeHandler}></ArcHierarchy>
            break;
        case "upload":
            fieldToDisplay = <ArcUpload config={props.config} changeHandler={props.changeHandler}></ArcUpload>
            break;
        default:
            break;
    }

    let fieldClass = "singlelinefield-data";
    if (props.config.Width !== undefined) {
        if (props.config.Width === "narrow") {
            fieldClass = "singlelinefield-narrow"
        }
        if (props.config.Width === "medium") {
            fieldClass = "singlelinefield-medium"
        }
    }

    return (
        <div className="singlelinefield-item">
            <div className={fieldClass}>
                {fieldToDisplay}
            </div>
        </div>
    )
};

export default SingleLineField;